import { FC } from 'react';

export const ProfileLoadingState: FC = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-slate-100">Profile</h2>
          <p className="text-gray-600 dark:text-slate-400 mt-1">
            Manage your professional profile
          </p>
        </div>
      </div>
      <div className="flex justify-center py-12">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600" />
      </div>
    </div>
  );
};
